module.exports = __webpack_public_path__ + "img/camp.34180145.jpg";